import { TabBar } from "shared/Components/tabBar";
import { useState } from "react";
import { ViewHosts } from "./viewHosts";
import { UpdateHosts } from "./updateHosts";

export const APPROVE_HOSTS = "Approved Hosts";

export const APPROVE_OR_REJECT_HOSTS = "Approve/Reject Hosts";

export const VIEW_JUDGE_TABS = [APPROVE_HOSTS, APPROVE_OR_REJECT_HOSTS];

export const ViewAllHosts = () => {
  const [selectTab, setSelectTab] = useState(VIEW_JUDGE_TABS[0]);
  
  return (
    <div className="flex flex-col App rounded-md min-h-screen lg:ml-[17rem] sm:pt-8 bg-white lg:p-10">
      <TabBar
        tabs={VIEW_JUDGE_TABS}
        onChangeTab={(index) => {
          setSelectTab(VIEW_JUDGE_TABS[index]);
        }}
      />
      {selectTab === APPROVE_HOSTS && <ViewHosts /> }
      {selectTab === APPROVE_OR_REJECT_HOSTS && <UpdateHosts />}
    </div>
  );
};
